import { render, staticRenderFns } from "./ScorecardSection.vue?vue&type=template&id=1f1ab17c&scoped=true"
import script from "./ScorecardSection.vue?vue&type=script&lang=js"
export * from "./ScorecardSection.vue?vue&type=script&lang=js"
import style0 from "./ScorecardSection.vue?vue&type=style&index=0&id=1f1ab17c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1ab17c",
  null
  
)

export default component.exports